import { render, staticRenderFns } from "./AddWorkItemPage.vue?vue&type=template&id=5ce0e836&"
import script from "./AddWorkItemPage.vue?vue&type=script&lang=js&"
export * from "./AddWorkItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports